import DynamicList from '@/client/components/DynamicList'
import ExportModel from '@client/models/export'

type ViewDataProps = { tab: any }

export default function ViewData({ tab }: ViewDataProps) {
    const exportModel = new ExportModel()
    const getArgs = (args: any) => {
        return {
            ...args, ...{
                outTableId: tab?.store?.data?.outTableId,
                inTableId: tab?.store?.data?.inTableId,
                fileId: tab?.store?.data?.fileId,
            }
        }
    }
    const waitCondition = (args: any) => {
        return args?.inTableId && args?.fileId
        return args?.dataList
    }

    return <DynamicList
        tab={tab}
        list={exportModel.viewData}
        getArgs={getArgs}
        waitCondition={waitCondition}
    />
}